import React from 'react';
import { styled } from 'buttered';

let ItemWrapper = styled('div')`
  padding: 6px 10px;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  border-radius: var(--vapor-radius-medium);
  transition: all 0.2s;

  @media screen and (max-width: 500px) {
    padding: 8px 14px;
    font-size: 17px;
  }
`;

export let Option = ({
  children,
  selected
}: {
  children: React.ReactNode;
  selected: boolean;
}) => {
  return (
    <ItemWrapper
      style={{
        background: selected && 'var(--vapor-accent-2)'
      }}
    >
      {children}
    </ItemWrapper>
  );
};
